import type { FaultlineId, KeywordMatch } from './types';

const KEYWORD_MAP: Record<string, FaultlineId[]> = {
  vpn: ['public-edge', 'lateral-movement'],
  firewall: ['public-edge', 'lateral-movement'],
  waf: ['public-edge'],
  'api gateway': ['public-edge'],
  oauth: ['identity-session'],
  oidc: ['identity-session'],
  sso: ['identity-session'],
  saml: ['identity-session'],
  jwt: ['identity-session'],
  mfa: ['identity-session'],
  admin: ['privileged-access'],
  root: ['privileged-access'],
  token: ['secrets-sprawl'],
  secret: ['secrets-sprawl'],
  secrets: ['secrets-sprawl'],
  env: ['secrets-sprawl'],
  vault: ['secrets-sprawl'],
  kms: ['secrets-sprawl'],
  ci: ['supply-chain'],
  pipeline: ['supply-chain'],
  'github actions': ['supply-chain'],
  gitlab: ['supply-chain'],
  dependency: ['supply-chain'],
  tenant: ['multi-tenant'],
  'multi-tenant': ['multi-tenant'],
  segmentation: ['lateral-movement'],
  network: ['lateral-movement'],
  egress: ['data-exfil'],
  exfil: ['data-exfil'],
  export: ['data-exfil'],
  config: ['change-misconfig'],
  terraform: ['change-misconfig'],
  kubernetes: ['change-misconfig', 'supply-chain'],
  observability: ['telemetry-blind'],
  logging: ['telemetry-blind'],
  metrics: ['telemetry-blind'],
};

const FAULTLINE_IDS: FaultlineId[] = [
  'public-edge',
  'identity-session',
  'privileged-access',
  'secrets-sprawl',
  'supply-chain',
  'multi-tenant',
  'lateral-movement',
  'data-exfil',
  'change-misconfig',
  'telemetry-blind',
];

const KEYWORD_REGEX: Record<string, RegExp> = Object.fromEntries(
  Object.keys(KEYWORD_MAP).map((keyword) => [
    keyword,
    new RegExp(`\\b${escapeRegex(keyword)}\\b`, 'i'),
  ])
);

function escapeRegex(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function matchKeywords(notes?: string): KeywordMatch {
  const hits: Record<FaultlineId, string[]> = Object.fromEntries(
    FAULTLINE_IDS.map((id) => [id, []])
  ) as Record<FaultlineId, string[]>;
  if (!notes) {
    return { hits, matchedKeywords: [] };
  }
  const matchedKeywords: string[] = [];
  for (const [keyword, faultlines] of Object.entries(KEYWORD_MAP)) {
    if (KEYWORD_REGEX[keyword]?.test(notes)) {
      matchedKeywords.push(keyword);
      for (const faultline of faultlines) {
        hits[faultline].push(keyword);
      }
    }
  }
  return { hits, matchedKeywords };
}
